import { useGlobalData } from "../data/GeneralData";
import { Link } from "react-router-dom";

import RegisterCallout from "../components/RegisterCallout";
import Speakers from "../components/Speakers";
import Ticker from "../components/Ticker";
import CertifiedLearning from "../components/CertifiedLearning";
import VideoSection from "../components/VideoSection";
import SpeakerData25 from "../data/SpeakerData25";
export default function PageHome() {
  const { date, year, location } = useGlobalData();
  return (
    <>
      <section className="bg-rounded-top bg-before-white overflow-hidden">
        <div className="video-banner">
          <video autoPlay disablePictureInPicture="true" loop muted>
            <source src="video/video-estancia.mp4" type="video/mp4" />
          </video>
          <div
            className="video-overlay"
            style={{ backgroundImage: `url(/img/bg-video-overlay.svg)` }}
          ></div>
        </div>

        <div className="purple-underlay bg-rounded-top"></div>
        <div className="container pb-5">
          <div className="row align-items-center pb-5">
            <div className="col-12 col-lg-4 text-center order-lg-last">
              <div className="row">
                <div className="col-12 text-center pb-5">
                  <img
                    className="img-fluid"
                    src="../img/logo-fincomp-stacked.svg"
                    alt="FinComp {year}"
                  />
                </div>
                <div className="col-12 text-center d-none d-lg-block">
                  {/* <Link
                    to="/Registration"
                    className="btn-purple-with-icon-inverted"
                  >
                    Register Now <i className="fa fa-arrow-right"></i>
                  </Link> */}
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-8">
              <div className="row">
                <div className="col-12 pb-4">
                  <h3 className=" color-white">
                    {date}, 2025 • {location}
                  </h3>
                </div>
                <div className="col-12" style={{ maxWidth: "750px" }}>
                  <h1 className=" color-white">
                    Experience the country's only{" "}
                    <mark className="purple-highlight">
                      compensation conference
                    </mark>{" "}
                    for all HR levels working in banks and{" "}
                    <span className="nobr">credit unions</span>
                  </h1>
                </div>
              </div>
            </div>
            <div className="col-12 text-center d-block d-lg-none pt-4">
              {/* <Link to="/Registration" className="btn-purple-with-icon">
                Register Now <i className="fa fa-arrow-right"></i>
              </Link> */}
            </div>
          </div>
        </div>
        <VideoSection />
      </section>

      <section className="bg-purple pb-5">
        <div className="container p-0">
          <dov className="row">
            <div className="col text-center">
              <h1 className="color-white">Featured Speakers</h1>
            </div>
          </dov>
          <Speakers speakers={SpeakerData25} colWidth="4" />
          <div id="speakersOverlay" className="modal-content hidden"></div>
        </div>
      </section>

      <Ticker />
      <img className="img-fluid" src="/img/img-photorow.webp" alt="" />

      <CertifiedLearning />

      <section>
        <div className="row justify-content-center pb-5 mb-5">
          <div className="col text-center">
            <h1 className="color-purple">Our Sponsors</h1>
            <p>
              FinComp 2025 wouldn't be possible without the support of our
              generous sponsors.
            </p>
          </div>
        </div>
        <div className="row justify-content-center align-items-center">
          <div className="col-12 mb-5 text-center">
            <h3 className="sponsor-label mb-3">Platinum</h3>
            <a
              href="https://newcleus.com/"
              target="_blank"
              rel="noreferrer"
              className="sponsor-card sponsor-platinum pt-4"
              // style={{ background: "#0f3246" }}
            >
              <div className="sponsor-logo platinum">
                <img
                  src="../img/sponsor-logo-newcleus.webp"
                  alt="Newcleus - Financial Inovation + Insight"
                />
              </div>
            </a>
          </div>

          <div className="col-12 text-center">
            <h3 className="sponsor-label mb-3">Gold</h3>
          </div>

          <div className="col-12 col-md-6 mb-5 text-center text-md-end">
            {/* <div className="col-12 col-md-6 mb-5 text-center"> */}
            <div className="sponsor-card-container">
              <a
                href="https://www.regulatoryarmor.com/"
                target="_blank"
                rel="noreferrer"
                className="sponsor-card sponsor-gold py-3"
              >
                <div className="sponsor-logo gold">
                  <img
                    src="../img/sponsor-logo-armoradvisoryservices.webp"
                    alt="ARMOR Advisory Services"
                    style={{ maxWidth: "24em" }}
                  />
                </div>
              </a>
            </div>
          </div>

          <div className="col-12 col-md-6 mb-5 text-center text-md-start">
            <div className="sponsor-card-container">
              <a
                href="https://ddjmyers.com/"
                target="_blank"
                rel="noreferrer"
                className="sponsor-card sponsor-gold"
              >
                <div className="sponsor-logo gold">
                  <img
                    src="../img/sponsor-logo-ddjmyers.webp"
                    alt="DDJ Myers"
                    style={{ maxWidth: "24em" }}
                  />
                </div>
              </a>
            </div>
          </div>

          <div className="col-12 text-center">
            <h3 className="sponsor-label mb-3">Silver</h3>
          </div>

          <div className="col-12 col-md-6 mb-5 text-center text-md-end">
            {/* <div className="col-12 col-md-6 mb-5 text-center"> */}
            <div className="sponsor-card-container">
              <a
                href="https://businessresultsllc.com/"
                target="_blank"
                rel="noreferrer"
                className="sponsor-card sponsor-silver py-3"
              >
                <div className="sponsor-logo silver">
                  <img
                    src="../img/sponsor-logo-businessresults.webp"
                    alt="Newcleus - Financial Inovation + Insight"
                    style={{ maxWidth: "20em" }}
                  />
                </div>
              </a>
            </div>
          </div>

          <div className="col-12 col-md-6 mb-5 text-center text-md-start">
            <div className="sponsor-card-container">
              <a
                href="https://motivosity.com/"
                target="_blank"
                rel="noreferrer"
                className="sponsor-card sponsor-silver py-3"
              >
                <div className="sponsor-logo silver">
                  <img
                    src="../img/sponsor-logo-motivosity.webp"
                    alt="Motivosity"
                    style={{ maxWidth: "20em" }}
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      <RegisterCallout className="bg-before-white" />
    </>
  );
}
